import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery } from "@tanstack/react-query";
import getHealthEventsInRange, {
  HealthEventsInRangeResponse,
} from "../http/getHealthEventsInRange";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

// Fetches cross-site health events active in [from, to]. Disabled until both
// bounds are provided, so the /operational/health page only queries once the
// operator has applied a date range.
export const useHealthEventsInRange = (
  from: string | null,
  to: string | null
) => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  return useQuery<HealthEventsInRangeResponse>(
    ["healthEventsInRange", from, to],
    async () => {
      const token = await getAuthTokenBlocking(getToken, relogin);
      return getHealthEventsInRange(token, from!, to!);
    },
    {
      enabled: !!from && !!to,
      staleTime: 60_000,
    }
  );
};
